import '../css/toggle.css'


export const ToggleLite = ({ handleChange, isChecked }) => {

    return (
        <div className="themeGroup toggle-lite">
            <div className="toggle-container">
                <input type="checkbox" id="check-lite" className={`toggle ${isChecked?'toggle-lite-on':'toggle-lite-off'}`} onChange={handleChange} checked={isChecked} />
                <label htmlFor="check-lite"></label>
            </div>
          
        </div>
       
    );
}
 